// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { compose, lifecycle } from "redux";
import { PlasmicExamTimer } from "./plasmic/cps/PlasmicExamTimer";
import { connect } from 'react-redux';
import Countdown from "react-countdown";
import { toggleExamComplete } from "../redux/reducers/userProgramsFull";




function ExamTimer_(props, ref) {
const [status, setStatus] = React.useState('good');
 
 const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if(parseInt(hours)==0 && parseInt(minutes)>10){
      setStatus('average')
  }else if(parseInt(hours)==0 && parseInt(minutes)<=10){
    setStatus('bad')
  }
  if (completed) {
    console.log('TIMER_COMPLETE', props.endTime)
     props.toggleExamComplete(true)
     return <div></div>;
   } else {
     if(days==0){
      return <div><div style={{ width:"100%"}}>{hours}h {minutes}m {seconds}s</div></div>;
     }else{
      return <div><div style={{ width:"100%"}}>{days} days {hours}h {minutes}m {seconds}s</div></div>;
     }
    
   }
   
 };

  return <PlasmicExamTimer root={{ ref }} {...props} 
    status={status}
      timer={{
        children: <Countdown date={props.examTimeEnd? props.examTimeEnd:props.endTime} renderer={renderer} />
      }}
  />;
}

const ExamTimer = React.forwardRef(ExamTimer_);

const mapStateToProps = state => ({
  selectedAttempt: state.userProgramsFullReducer.selectedAttempt,
  examTimeEnd: state.userProgramsFullReducer.examTimeEnd,
});

const mapDispatchToProps = dispatch => ({
  toggleExamComplete:bool => dispatch(toggleExamComplete(bool))
});


export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )
 
  
)(ExamTimer);
